// extracted by mini-css-extract-plugin
module.exports = {"container":"Notes_container__1vwJ_","loaderWrap":"Notes_loaderWrap__351ss"};